module.exports = __webpack_public_path__ + "static/media/CAN.1ff288d0.svg";